import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoaderComponent } from '../shared/components/loader/loader.component';

@Component({
  selector: 'app-mobile-display',
  templateUrl: './mobile-display.component.html',
  styleUrl: './mobile-display.component.css',
  standalone: true,
  imports: [LoaderComponent, RouterModule],
})
export class MobileDisplayComponent {
  public showSpinner = true;
  constructor(
    public router: Router,
    private route: ActivatedRoute,
  ) {
    this.showSpinner = false;

  }
}
